// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Lock = ({ size, stroke, fill }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill}
      stroke={stroke}
      strokeWidth='2px'
    >
      <rect x='8.69' y='21.07' width='30.62' height='22.93' rx='3.07' ry='3.07' />
      <path d='M35.43,15.42v5.65H12.57v-5.65c0-6.31,5.12-11.42,11.43-11.42,3.15,0,6.01,1.28,8.08,3.35,2.07,2.06,3.35,4.92,3.35,8.07Z' />
      <path d='M26.05,29.52c0,.82-.48,1.53-1.17,1.85v5.66h-1.76v-5.66c-.69-.33-1.17-1.03-1.17-1.85,0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05Z' />
    </svg>
  );
};
